'use client';

import { useEffect, useRef } from 'react';
// eslint-disable-next-line import/no-unresolved
import { useInstantSearch } from 'react-instantsearch-next';
import useIsSearchOpen from 'global-state/isSearchOpen/useIsSearchOpen';

/**
 * When the search modal is closed, clear the InstantSearch query
 * so the next time the user opens the modal they see an empty search box.
 */
const ClearModalSearchQueryWhenClosed = () => {
  const { setIndexUiState } = useInstantSearch();
  const isSearchOpen = useIsSearchOpen();
  const wasOpenRef = useRef(false);

  useEffect(() => {
    if (wasOpenRef.current && !isSearchOpen) {
      setIndexUiState(prev => ({ ...prev, query: '' }));
    }
    wasOpenRef.current = isSearchOpen;
  }, [isSearchOpen, setIndexUiState]);

  return null;
};

export default ClearModalSearchQueryWhenClosed;
